import { render, staticRenderFns } from "./Bore.vue?vue&type=template&id=30c7726c&"
import script from "./Bore.vue?vue&type=script&lang=ts&"
export * from "./Bore.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports